export const modalReservationDirect = {
  header: {
    title: "Prenotazioni dirette dal web",
    subtitle: "Imposta ciò che l'ospite vede e come si applicano le regole.",
  },
  tabs: {
    reservations: "Stato delle prenotazioni",
    ratePlans: "Tariffe",
    promotions: "Promozioni",
    addons: "Addebiti aggiuntivi",
    payments: "Prezzi e pagamenti",
    share: "Condividi",
  },
  common: {
    close: "Chiudi",
    updating: "Aggiornamento…",
    hotel: "Hotel",
    apartment: "Appartamento",
    visible: "Visibile",
    default: "Predefinito",
    dragToReorder: "Trascina per riordinare",
    saving: "Salvataggio…",
    preview: "Anteprima",
  },
  toast: {
    successTitle: "Operazione riuscita",
  },
  save: {
    ratePlans: "Salva tariffe",
    promotions: "Salva promozioni",
    addons: "Salva addebiti",
    default: "Salva",
  },
  reservations: {
    cardTitle: "Stato delle prenotazioni dirette",
    cardDesc: "Attiva o disattiva la disponibilità delle prenotazioni dirette (a livello globale e per unità).",
    activateTitle: "Abilita le prenotazioni dirette",
    activateHelp: "Se questa opzione è disattivata, non puoi abilitare le singole unità.",
    colName: "Alloggio / Unità",
    colCapacity: "Capacità",
    colAvailable: "Disponibile",
    emptyUnits: "Nessuna unità configurata per questa struttura.",
  },
  ratePlans: {
    title: "Tariffe mostrate nella prenotazione diretta",
    hotelDesc: "Imposta quali tariffe vengono mostrate per ogni tipo di camera",
    apartmentDesc: "Scegli quali piani tariffari vede l'ospite, qual è quello predefinito e l'ordine",
    loading: "Caricamento delle tariffe…",
    emptyApartment: "Nessuna tariffa configurata per questa struttura.",
    emptyHotel: "Nessun tipo di camera configurato per questo hotel.",
    emptyRoom: "Nessuna tariffa configurata per questa camera.",
    colTarifa: "Tariffa",
    colVisibleName: "Nome visualizzato",
    visibleNameTooltip: "Nome facoltativo da mostrare all'ospite",
    namePlaceholderApartment: "es. Non rimborsabile / Flessibile",
    namePlaceholderHotel: "es. Colazione inclusa",
    derivedBadge: "Derivata",
    rulesApartment: "Regole: almeno 1 visibile e 1 predefinita (che deve essere visibile).",
    rulesHotel: "Ogni camera deve avere almeno 1 tariffa visibile e 1 predefinita.",
  },
  rooms: {
    ratesCount: "{count} tariffa | {count} tariffe",
    meta: "Capacità: {capacity} • Adulti: {adults} • Bambini: {children}",
  },
  promotions: {
    title: "Promozioni nella prenotazione diretta",
    desc: "Controlla quali vengono mostrate, se si applicano automaticamente e l'ordine.",
    loading: "Caricamento delle promozioni…",
    empty: "Nessuna promozione configurata per questa struttura.",
    colPromo: "Promozione",
    colBadge: "Etichetta",
    badgeTooltip: "Testo breve (es. -10%, Offerta, Early Bird).",
    colAuto: "Applica automaticamente",
    colStackable: "Cumulabile",
    badgePlaceholder: "es. -10% / Offerta",
    tip: "Suggerimento: se non vuoi che una promozione influisca sul prezzo finale, disattiva “Applica automaticamente” e mantienila visibile.",
    fromDate: "Dal {date}",
    untilDate: "Fino al {date}",
  },
  addons: {
    loading: "Caricamento delle impostazioni…",
    subtabOccupancy: "Sconto per occupazione",
    subtabExtraGuest: "Addebito per ospite aggiuntivo",
    baseOccupancyTitle: "Occupazione base",
    baseOccupancyDesc: "Il prezzo abituale corrisponde a questa occupazione. Per un numero inferiore di ospiti applichi una riduzione.",
    guestsLabel: "ospiti",
    headOccupancy: "Occupazione",
    headRule: "Regola",
    headValue: "Valore",
    headActive: "Attivo",
    guestWord: "ospite | ospiti",
    usualPrice: "Prezzo abituale",
    modePercent: "Riduzione %",
    modeFixed: "Riduzione fissa (per notte)",
    occupancyExample: "Esempio: base 4 ospiti e sconti per 3, 2 e 1.",
    configTitle: "Impostazioni",
    configDesc: "Applica un supplemento per ogni ospite aggiuntivo oltre l'occupazione inclusa.",
    activate: "Abilita",
    includedTitle: "Occupazione inclusa",
    includedDesc: "Presa automaticamente dalla capacità dell'alloggio.",
    maxExtraLabel: "Numero massimo di ospiti aggiuntivi consentiti",
    maxHelpHtml: "Quanti ospiti possono essere aggiunti <b>oltre l'occupazione inclusa</b>.<br />Se imposti <b>0</b>, non sono consentiti ospiti aggiuntivi.<br />Se lo lasci vuoto, non c'è limite.",
    chargeTypeLabel: "Tipo di addebito",
    chargeTypeFixed: "Importo fisso",
    chargeTypePercentage: "Percentuale",
    chargeTypeHelp: "Fisso: {currency} per ospite aggiuntivo. Percentuale: % del prezzo base.",
    priceLabel: "Prezzo per ospite aggiuntivo",
    appliesHelp: "Applicato per ogni ospite aggiuntivo.",
    appliesBlockedNote: "(Nessun ospite aggiuntivo consentito quando il massimo è 0)",
    applicationLabel: "Applicazione",
    applicationNote: "Per ora questo addebito si applica per notte.",
    previewFixed: "Ogni ospite aggiuntivo aggiunge <b>{amount}</b> per notte.",
    previewPercent: "Ogni ospite aggiuntivo aggiunge <b>{percent}%</b> del prezzo base per notte.",
    singleValueNote: "Questo è un <b>valore unico</b> (es. +10 {currency} o +15% per ospite aggiuntivo).",
  },
  payments: {
    title: "Prezzi e pagamenti",
    desc: "Tipo di addebito e sconti per le prenotazioni dirette.",
    paymentTypeTitle: "Tipo di pagamento",
    onArrivalLabel: "Paga all'arrivo",
    onArrivalDesc: "L'ospite prenota e paga direttamente all'arrivo.",
    onlineLabel: "Pagamento online",
    onlineDesc: "L'ospite paga online al momento del completamento della prenotazione.",
    discountsTitle: "Sconti",
    enableDiscount: "Abilita lo sconto sulle prenotazioni dirette",
    discountTypeTitle: "Tipo di sconto",
    typePercentage: "Percentuale",
    typePercentageDesc: "Sconto proporzionale al totale.",
    typeFixed: "Fisso",
    typeFixedDesc: "Importo fisso da detrarre.",
    valueTitle: "Valore",
    placeholderPercentage: "es. 10",
    placeholderFixed: "es. 15.00",
    helpPercentage: "Massimo 100%. Applicato al totale.",
    helpFixed: "Viene detratto un importo fisso in {currency}.",
    previewPercentage: "Verrà applicato uno sconto del {percent}%.",
    previewFixed: "Verrà applicato uno sconto di {amount}.",
  },
  share: {
    title: "Condividi",
    desc: "Copia il link della prenotazione diretta e condividilo su WhatsApp o apri la vista dell'ospite.",
    linkLabel: "Link di prenotazione",
    linkHelp: "Questo è il link che condividi con gli ospiti.",
    viewAsGuest: "Visualizza come ospite",
    tip: "Suggerimento: condividi questo link nella tua bio, nei messaggi automatici e nelle campagne.",
    whatsappMessage: "Ciao 👋 Ecco il link per prenotare: {link}",
  },
  errors: {
    loadRatePlans: "Impossibile caricare le tariffe.",
    saveRatePlans: "Impossibile salvare le tariffe.",
    roomMinVisible: 'La camera "{name}" deve avere almeno 1 tariffa visibile.',
    roomExactlyOneDefault: 'La camera "{name}" deve avere esattamente 1 tariffa predefinita.',
    roomDefaultMustBeVisible: 'In "{name}", la tariffa predefinita deve essere visibile.',
    aptMinVisible: "Devi mantenere almeno 1 tariffa visibile.",
    aptExactlyOneDefault: "Deve esserci esattamente 1 tariffa predefinita.",
    aptDefaultMustBeVisible: "La tariffa predefinita deve essere visibile.",
    loadPromotions: "Impossibile caricare le promozioni.",
    savePromotions: "Impossibile salvare le promozioni.",
    saveAddons: "Impossibile salvare gli addebiti aggiuntivi.",
    maxExtraRange: "Il numero massimo di ospiti aggiuntivi deve essere compreso tra 0 e 50 (o vuoto = nessun limite).",
    extraPriceInvalid: "Il prezzo per ospite aggiuntivo deve essere valido (>= 0).",
    percentRange: "La percentuale deve essere compresa tra 0 e 100.",
    baseOccupancyRange: "L'occupazione base deve essere compresa tra 1 e {max}.",
    discountValuesInvalid: "I valori di sconto devono essere numeri validi (>= 0).",
    discountPercentMax: "Gli sconti percentuali non possono superare 100.",
    updateFailed: "Impossibile aggiornare.",
    updateUnitFailed: "Impossibile aggiornare lo stato dell'unità.",
    updateGlobalFailed: "Impossibile aggiornare lo stato globale.",
    noLinkCopy: "Nessun link da copiare.",
    copyFailed: "Impossibile copiare il link.",
    noLinkShare: "Nessun link da condividere.",
    noLinkOpen: "Nessun link da aprire.",
    updatePaymentType: "Impossibile aggiornare il tipo di pagamento.",
    savePayments: "Impossibile salvare le modifiche.",
  },
  success: {
    ratePlansSaved: "Tariffe salvate con successo.",
    promotionsSaved: "Promozioni salvate con successo.",
    addonsSaved: "Addebiti aggiuntivi salvati con successo.",
    updated: "Aggiornato con successo.",
    globalUpdated: "Stato globale aggiornato.",
    linkCopied: "Link copiato.",
    changesSaved: "Modifiche salvate.",
  },
};
